import { render, staticRenderFns } from "./OrdersSearchInput.vue?vue&type=template&id=09698d05&scoped=true"
import script from "./OrdersSearchInput.vue?vue&type=script&lang=js"
export * from "./OrdersSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09698d05",
  null
  
)

export default component.exports